
import * as React from "react"
import { Button as ShadcnButton } from "@/components/ui/button"
import { cn } from "@/lib/utils"

export interface EnhancedButtonProps extends React.ComponentPropsWithoutRef<typeof ShadcnButton> {
  children?: React.ReactNode;
  className?: string;
  variant?: "default" | "destructive" | "outline" | "secondary" | "ghost" | "link";
  size?: "default" | "sm" | "lg" | "icon";
  asChild?: boolean;
  type?: "button" | "submit" | "reset";
}

export const EnhancedButton = React.forwardRef<HTMLButtonElement, EnhancedButtonProps>(
  ({ className, variant, size, asChild, children, ...props }, ref) => {
    return (
      <ShadcnButton
        className={cn(className)}
        ref={ref}
        variant={variant}
        size={size}
        asChild={asChild}
        {...props}
      >
        {children}
      </ShadcnButton>
    );
  }
);
EnhancedButton.displayName = "EnhancedButton";

// Re-export the original Button with the name Button
export { EnhancedButton as Button };
